import React from 'react';
import { Box, Container, Heading, Text, VStack, Link, Divider } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

// Termos de Serviço — página PÚBLICA (sem auth).
const Terms: React.FC = () => {
  const CONTATO = 'contato@aplicaiaapp.com';
  return (
    <Box minH="100vh" bg="gray.50" py={10}>
      <Container maxW="3xl" bg="white" p={{ base: 6, md: 10 }} borderRadius="lg" shadow="sm">
        <VStack align="stretch" spacing={5}>
          <Box>
            <Link as={RouterLink} to="/" color="brand.600" fontSize="sm">← Voltar</Link>
            <Heading size="lg" mt={3} color="brand.700">Termos de Serviço</Heading>
            <Text fontSize="sm" color="gray.500" mt={1}>Última atualização: 11 de junho de 2026</Text>
          </Box>

          <Text>
            Estes Termos regem o uso da plataforma <strong>Aplica IA</strong>. Ao criar uma conta ou
            usar o serviço, você concorda com eles.
          </Text>

          <Section title="1. O serviço">
            <Text>A Aplica IA permite conectar suas fontes de dados e buscar/conversar com esse conteúdo usando IA. Os recursos disponíveis dependem do plano contratado.</Text>
          </Section>

          <Section title="2. Sua conta">
            <Text>Você é responsável por manter suas credenciais seguras e por todas as atividades na sua conta. Deve fornecer informações verdadeiras e ter autorização para conectar as fontes que conectar.</Text>
          </Section>

          <Section title="3. Uso aceitável">
            <Text>Você não deve usar a plataforma para fins ilegais, para violar direitos de terceiros, nem tentar comprometer a segurança do serviço. Você é responsável pelo conteúdo que conecta e ingere.</Text>
          </Section>

          <Section title="4. Dados e privacidade">
            <Text>O tratamento de dados segue a nossa <Link as={RouterLink} to="/privacidade" color="brand.600">Política de Privacidade</Link>. Você mantém a titularidade do seu conteúdo; concede à Aplica IA o direito de processá-lo apenas para prestar o serviço.</Text>
          </Section>

          <Section title="5. Planos e pagamento">
            <Text>Planos pagos são cobrados conforme contratado, por meio do provedor de pagamento. Limites de uso (usuários, coleções, volume e orçamento de IA) seguem o plano.</Text>
          </Section>

          <Section title="6. Disponibilidade e isenções">
            <Text>Empenhamo-nos para manter o serviço disponível, mas ele é fornecido "como está", sem garantias de disponibilidade ininterrupta. Respostas geradas por IA podem conter imprecisões; confira informações críticas.</Text>
          </Section>

          <Section title="7. Encerramento">
            <Text>Você pode encerrar a conta a qualquer momento. Podemos suspender contas que violem estes Termos. Após o encerramento, seus dados são removidos conforme a Política de Privacidade.</Text>
          </Section>

          <Section title="8. Alterações">
            <Text>Podemos atualizar estes Termos; mudanças relevantes serão comunicadas. O uso continuado após a atualização implica concordância.</Text>
          </Section>

          <Divider />
          <Section title="9. Contato">
            <Text>Dúvidas: <Link href={`mailto:${CONTATO}`} color="brand.600">{CONTATO}</Link>.</Text>
          </Section>
        </VStack>
      </Container>
    </Box>
  );
};

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Box>
    <Heading size="sm" mb={2} color="gray.700">{title}</Heading>
    <VStack align="stretch" spacing={1} color="gray.700" fontSize="sm">
      {children}
    </VStack>
  </Box>
);

export default Terms;
